import { call, put } from 'redux-saga/effects';
import {
  updateExcelTransactionFailure,
  updateExcelTransactionSuccess,
  fetchAllExcelTransactionsRequest,
  setTransactionsReviewedRequest,
} from '../actions';
import { updateExcelTransaction } from '../api';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { UpdateExcelTransactionRequestAction } from '../types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import { buildTransactionsRefreshFilters } from 'utils/entityTransactionsRequestFilters';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* updateExcelTransactionSaga(
  action: UpdateExcelTransactionRequestAction
) {
  try {
    const { organisationId, transactionUuid, body, refreshParams } =
      action.payload;

    const updateResponse: ApiResponse = yield call(
      updateExcelTransaction,
      organisationId,
      transactionUuid,
      body
    );

    const err: ApiError | null = checkResponse(updateResponse?.responseMessage);
    if (err) {
      if (
        updateResponse.data?.validationErrors &&
        updateResponse.data?.validationErrors?.length > 0
      ) {
        const fieldNames =
          updateResponse.data?.validationErrors?.filter(Boolean);
        const separator = err.message.endsWith('.') ? ' ' : '. ';
        if (fieldNames.length === 1) {
          err.message += `${separator}${fieldNames[0]} is a required field`;
        } else if (fieldNames.length > 1) {
          err.message += `${separator}${fieldNames.join(
            ', '
          )} are required fields`;
        }
      } else {
        err.message = updateResponse.responseMessage?.message;
      }
      throw err;
    }

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: updateResponse.responseMessage?.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(updateExcelTransactionSuccess());

    if (refreshParams) {
      const refreshFilters = buildTransactionsRefreshFilters({
        tableFilters: refreshParams.filters,
        tabFileImportIds: refreshParams.tabFileImportIds,
      });
      yield put(
        fetchAllExcelTransactionsRequest(
          organisationId,
          refreshParams.page,
          refreshParams.pageSize,
          refreshFilters
        )
      );
      // After successful save, mark as reviewed when requested (e.g. receipts review flow).
      if (refreshParams.markAsReviewedIds?.length) {
        yield put(
          setTransactionsReviewedRequest(
            organisationId,
            refreshParams.markAsReviewedIds,
            refreshParams.page,
            refreshParams.pageSize,
            refreshParams.filters,
            refreshParams.tabFileImportIds,
            true
          )
        );
      }
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(updateExcelTransactionFailure());
  }
}
